// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[0].use[1]!./fonts.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --landing-fg: #ffffff;
  --landing-shadow: 0 2px 24px rgba(0, 0, 0, 0.45);
  --landing-button-bg: rgba(255, 255, 255, 0.12);
  --landing-button-bg-hover: rgba(255, 255, 255, 0.22);
  --landing-button-border: rgba(255, 255, 255, 0.35);
}

* {
  box-sizing: border-box;
}

html,
body {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  font-family: "Quilt Sans", sans-serif;
  font-weight: 300;
  color: var(--landing-fg);
  background: #0b0b10;
}

.landing {
  /* Resolved at runtime relative to the HTML document (dist/index.html),
     so we don't bundle the file via webpack — it's copied by CopyPlugin. */
  background-image: url("./assets/landing.webp");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-color: #0b0b10;
}

.landing__page {
  position: fixed;
  inset: 0;
  display: grid;
  grid-template-rows: 1fr auto auto auto;
  align-items: center;
  justify-items: center;
  padding: max(env(safe-area-inset-top), 24px) 24px
    max(env(safe-area-inset-bottom), 10px);
  background: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 0.45) 0%,
    rgba(0, 0, 0, 0.15) 35%,
    rgba(0, 0, 0, 0.55) 100%
  );
}

.landing__title {
  align-self: start;
  margin: 0;
  margin-top: clamp(24px, 8vh, 80px);
  font-family: "Quilt Serif", serif;
  font-weight: 300;
  font-size: clamp(40px, 9vw, 72px);
  letter-spacing: 0.02em;
  text-align: center;
  text-shadow: var(--landing-shadow);
}

.landing__logo {
  display: block;
  align-self: start;
  justify-self: center;
  width: clamp(180px, 60vw, 320px);
  max-width: 100%;
  height: auto;
  margin-top: clamp(24px, 8vh, 80px);
}

.landing__prompt {
  margin: 2.2vh;
  font-size: clamp(2.5vh, 4.2vw, 22px);
  font-family: "Quilt Serif", serif;
  font-weight: 500;
  line-height: 1.2;
  text-align: center;
  text-shadow: var(--landing-shadow);
  max-width: 560px;
}

.landing__buttons {
  align-self: end;
  margin-bottom: clamp(8px, 2.5vh, 24px);
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: clamp(8px, 2.5vw, 18px);
  width: 100%;
  max-width: 560px;
}

.landing__footer {
  align-self: start;
  justify-self: center;
  margin-bottom: 2px;
  padding: 0 16px;
  max-width: 640px;
  text-align: center;
}

.landing__footer-text {
  margin: 0;
  font-size: clamp(10px, 1.9vw, 12px);
  line-height: 1.3;
  color: rgba(255, 255, 255, 0.76);
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.85), 0 0 6px rgba(0, 0, 0, 0.85);
}

.landing__button {
  position: relative;
  aspect-ratio: 1 / 1;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-end;
  padding: 0;
  overflow: hidden;
  text-decoration: none;
  color: var(--landing-fg);
  background: var(--landing-button-bg);
  border: 1px solid var(--landing-button-border);
  border-radius: 18px;
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  transition: transform 120ms ease, background 120ms ease;
  user-select: none;
  -webkit-tap-highlight-color: transparent;
}

.landing__button:active {
  transform: scale(0.97);
  background: var(--landing-button-bg-hover);
}

/* Photo only in the top 2/3; bottom 1/3 stays frosted (backdrop) + label */
.landing__button-img {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: calc(100% * 3 / 4);
  z-index: 0;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-color: rgba(255, 255, 255, 0.04);
  border-radius: 17px 17px 0 0;
}

.landing__button-img[data-img="1"] {
  background-image: url("./assets/btn1.jpg");
}
.landing__button-img[data-img="2"] {
  background-image: url("./assets/btn2.jpg");
}
.landing__button-img[data-img="3"] {
  background-image: url("./assets/btn3.jpg");
}

.landing__button-label {
  position: relative;
  z-index: 1;
  flex: 0 0 calc(100% / 4);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 10px;
  font-size: clamp(12px, 3.6vw, 16px);
  font-weight: 600;
  text-align: center;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.55);
  /* Slight tint so the name reads on the blurred strip without hiding the glass */
  background: linear-gradient(
    to top,
    rgba(0, 0, 0, 0.28) 0%,
    rgba(0, 0, 0, 0.06) 100%
  );
}

.landing__loading-overlay {
  position: fixed;
  inset: 0;
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 14px;
  background: rgba(6, 8, 14, 0.68);
  opacity: 0;
  pointer-events: none;
  transition: opacity 140ms ease;
}

.landing__loading-spinner {
  width: clamp(58px, 14vw, 76px);
  height: clamp(58px, 14vw, 76px);
  border-radius: 50%;
  border: 4px solid rgba(255, 255, 255, 0.3);
  border-top-color: #ffffff;
  animation: landing-spin 0.9s linear infinite;
}

.landing__loading-text {
  margin: 0;
  font-family: "Quilt Sans", sans-serif;
  font-size: clamp(16px, 3.8vw, 22px);
  font-weight: 300;
  color: #ffffff;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.5);
}

body.landing--navigating .landing__loading-overlay {
  opacity: 1;
  pointer-events: auto;
}

body.landing--navigating .landing__page {
  pointer-events: none;
}

@keyframes landing-spin {
  to {
    transform: rotate(360deg);
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/landing.css"],"names":[],"mappings":"AAEA;EACE,qBAAqB;EACrB,gDAAgD;EAChD,8CAA8C;EAC9C,oDAAoD;EACpD,kDAAkD;AACpD;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;EAEE,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,qCAAqC;EACrC,gBAAgB;EAChB,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE;2EACyE;EACzE,8CAA8C;EAC9C,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,sCAAsC;EACtC,mBAAmB;EACnB,qBAAqB;EACrB;0CACwC;EACxC;;;;;GAKC;AACH;;AAEA;EACE,iBAAiB;EACjB,SAAS;EACT,kCAAkC;EAClC,iCAAiC;EACjC,gBAAgB;EAChB,iCAAiC;EACjC,sBAAsB;EACtB,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,oBAAoB;EACpB,gCAAgC;EAChC,eAAe;EACf,YAAY;EACZ,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,iCAAiC;EACjC,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,sCAAsC;EACtC,aAAa;EACb,gDAAgD;EAChD,4BAA4B;EAC5B,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,mCAAmC;EACnC,gBAAgB;EAChB,gCAAgC;EAChC,uEAAuE;AACzE;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,yBAAyB;EACzB,UAAU;EACV,gBAAgB;EAChB,qBAAqB;EACrB,wBAAwB;EACxB,oCAAoC;EACpC,8CAA8C;EAC9C,mBAAmB;EACnB,0BAA0B;EAC1B,kCAAkC;EAClC,uDAAuD;EACvD,iBAAiB;EACjB,wCAAwC;AAC1C;;AAEA;EACE,sBAAsB;EACtB,0CAA0C;AAC5C;;AAEA,2EAA2E;AAC3E;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,0BAA0B;EAC1B,UAAU;EACV,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;EAC5B,2CAA2C;EAC3C,4BAA4B;AAC9B;;AAEA;EACE,0CAA0C;AAC5C;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,wBAAwB;EACxB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,mCAAmC;EACnC,gBAAgB;EAChB,kBAAkB;EAClB,0CAA0C;EAC1C,gFAAgF;EAChF;;;;GAIC;AACH;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,SAAS;EACT,gCAAgC;EAChC,UAAU;EACV,oBAAoB;EACpB,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,+BAA+B;EAC/B,kBAAkB;EAClB,0CAA0C;EAC1C,yBAAyB;EACzB,4CAA4C;AAC9C;;AAEA;EACE,SAAS;EACT,qCAAqC;EACrC,mCAAmC;EACnC,gBAAgB;EAChB,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF","sourcesContent":["@import \"./fonts.css\";\r\n\r\n:root {\r\n  --landing-fg: #ffffff;\r\n  --landing-shadow: 0 2px 24px rgba(0, 0, 0, 0.45);\r\n  --landing-button-bg: rgba(255, 255, 255, 0.12);\r\n  --landing-button-bg-hover: rgba(255, 255, 255, 0.22);\r\n  --landing-button-border: rgba(255, 255, 255, 0.35);\r\n}\r\n\r\n* {\r\n  box-sizing: border-box;\r\n}\r\n\r\nhtml,\r\nbody {\r\n  margin: 0;\r\n  padding: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  overflow: hidden;\r\n  font-family: \"Quilt Sans\", sans-serif;\r\n  font-weight: 300;\r\n  color: var(--landing-fg);\r\n  background: #0b0b10;\r\n}\r\n\r\n.landing {\r\n  /* Resolved at runtime relative to the HTML document (dist/index.html),\r\n     so we don't bundle the file via webpack — it's copied by CopyPlugin. */\r\n  background-image: url(\"./assets/landing.webp\");\r\n  background-size: cover;\r\n  background-position: center;\r\n  background-repeat: no-repeat;\r\n  background-color: #0b0b10;\r\n}\r\n\r\n.landing__page {\r\n  position: fixed;\r\n  inset: 0;\r\n  display: grid;\r\n  grid-template-rows: 1fr auto auto auto;\r\n  align-items: center;\r\n  justify-items: center;\r\n  padding: max(env(safe-area-inset-top), 24px) 24px\r\n    max(env(safe-area-inset-bottom), 10px);\r\n  background: linear-gradient(\r\n    to bottom,\r\n    rgba(0, 0, 0, 0.45) 0%,\r\n    rgba(0, 0, 0, 0.15) 35%,\r\n    rgba(0, 0, 0, 0.55) 100%\r\n  );\r\n}\r\n\r\n.landing__title {\r\n  align-self: start;\r\n  margin: 0;\r\n  margin-top: clamp(24px, 8vh, 80px);\r\n  font-family: \"Quilt Serif\", serif;\r\n  font-weight: 300;\r\n  font-size: clamp(40px, 9vw, 72px);\r\n  letter-spacing: 0.02em;\r\n  text-align: center;\r\n  text-shadow: var(--landing-shadow);\r\n}\r\n\r\n.landing__logo {\r\n  display: block;\r\n  align-self: start;\r\n  justify-self: center;\r\n  width: clamp(180px, 60vw, 320px);\r\n  max-width: 100%;\r\n  height: auto;\r\n  margin-top: clamp(24px, 8vh, 80px);\r\n}\r\n\r\n.landing__prompt {\r\n  margin: 2.2vh;\r\n  font-size: clamp(2.5vh, 4.2vw, 22px);\r\n  font-family: \"Quilt Serif\", serif;\r\n  font-weight: 500;\r\n  line-height: 1.2;\r\n  text-align: center;\r\n  text-shadow: var(--landing-shadow);\r\n  max-width: 560px;\r\n}\r\n\r\n.landing__buttons {\r\n  align-self: end;\r\n  margin-bottom: clamp(8px, 2.5vh, 24px);\r\n  display: grid;\r\n  grid-template-columns: repeat(3, minmax(0, 1fr));\r\n  gap: clamp(8px, 2.5vw, 18px);\r\n  width: 100%;\r\n  max-width: 560px;\r\n}\r\n\r\n.landing__footer {\r\n  align-self: start;\r\n  justify-self: center;\r\n  margin-bottom: 2px;\r\n  padding: 0 16px;\r\n  max-width: 640px;\r\n  text-align: center;\r\n}\r\n\r\n.landing__footer-text {\r\n  margin: 0;\r\n  font-size: clamp(10px, 1.9vw, 12px);\r\n  line-height: 1.3;\r\n  color: rgba(255, 255, 255, 0.76);\r\n  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.85), 0 0 6px rgba(0, 0, 0, 0.85);\r\n}\r\n\r\n.landing__button {\r\n  position: relative;\r\n  aspect-ratio: 1 / 1;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: stretch;\r\n  justify-content: flex-end;\r\n  padding: 0;\r\n  overflow: hidden;\r\n  text-decoration: none;\r\n  color: var(--landing-fg);\r\n  background: var(--landing-button-bg);\r\n  border: 1px solid var(--landing-button-border);\r\n  border-radius: 18px;\r\n  backdrop-filter: blur(8px);\r\n  -webkit-backdrop-filter: blur(8px);\r\n  transition: transform 120ms ease, background 120ms ease;\r\n  user-select: none;\r\n  -webkit-tap-highlight-color: transparent;\r\n}\r\n\r\n.landing__button:active {\r\n  transform: scale(0.97);\r\n  background: var(--landing-button-bg-hover);\r\n}\r\n\r\n/* Photo only in the top 2/3; bottom 1/3 stays frosted (backdrop) + label */\r\n.landing__button-img {\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  height: calc(100% * 3 / 4);\r\n  z-index: 0;\r\n  background-size: cover;\r\n  background-position: center;\r\n  background-repeat: no-repeat;\r\n  background-color: rgba(255, 255, 255, 0.04);\r\n  border-radius: 17px 17px 0 0;\r\n}\r\n\r\n.landing__button-img[data-img=\"1\"] {\r\n  background-image: url(\"./assets/btn1.jpg\");\r\n}\r\n.landing__button-img[data-img=\"2\"] {\r\n  background-image: url(\"./assets/btn2.jpg\");\r\n}\r\n.landing__button-img[data-img=\"3\"] {\r\n  background-image: url(\"./assets/btn3.jpg\");\r\n}\r\n\r\n.landing__button-label {\r\n  position: relative;\r\n  z-index: 1;\r\n  flex: 0 0 calc(100% / 4);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 0 10px;\r\n  font-size: clamp(12px, 3.6vw, 16px);\r\n  font-weight: 600;\r\n  text-align: center;\r\n  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.55);\r\n  /* Slight tint so the name reads on the blurred strip without hiding the glass */\r\n  background: linear-gradient(\r\n    to top,\r\n    rgba(0, 0, 0, 0.28) 0%,\r\n    rgba(0, 0, 0, 0.06) 100%\r\n  );\r\n}\r\n\r\n.landing__loading-overlay {\r\n  position: fixed;\r\n  inset: 0;\r\n  z-index: 999;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  flex-direction: column;\r\n  gap: 14px;\r\n  background: rgba(6, 8, 14, 0.68);\r\n  opacity: 0;\r\n  pointer-events: none;\r\n  transition: opacity 140ms ease;\r\n}\r\n\r\n.landing__loading-spinner {\r\n  width: clamp(58px, 14vw, 76px);\r\n  height: clamp(58px, 14vw, 76px);\r\n  border-radius: 50%;\r\n  border: 4px solid rgba(255, 255, 255, 0.3);\r\n  border-top-color: #ffffff;\r\n  animation: landing-spin 0.9s linear infinite;\r\n}\r\n\r\n.landing__loading-text {\r\n  margin: 0;\r\n  font-family: \"Quilt Sans\", sans-serif;\r\n  font-size: clamp(16px, 3.8vw, 22px);\r\n  font-weight: 300;\r\n  color: #ffffff;\r\n  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.5);\r\n}\r\n\r\nbody.landing--navigating .landing__loading-overlay {\r\n  opacity: 1;\r\n  pointer-events: auto;\r\n}\r\n\r\nbody.landing--navigating .landing__page {\r\n  pointer-events: none;\r\n}\r\n\r\n@keyframes landing-spin {\r\n  to {\r\n    transform: rotate(360deg);\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
